import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import { twMerge } from 'tailwind-merge';

import { useWindowSize } from 'hooks/useWindowSize';

import Caret from 'assets/icons/caret.png';

import styles from './MediaSlider.module.scss';

interface IMediaSlider {
  children: JSX.Element[];
}

const MediaSlider = ({ children }: IMediaSlider): JSX.Element => {
  const minVariableWidth = 393;
  const mobileViewScreenSize = 860;
  const tabletViewScreenSize = 1320;
  const carouselRef = useRef<Slider>(null);
  const [width] = useWindowSize();
  const [slidesToShow, setSlidesToShow] = useState<number>(1);

  useEffect(() => {
    if (width <= tabletViewScreenSize && width > mobileViewScreenSize) {
      setSlidesToShow(2);
    }

    if (width <= mobileViewScreenSize || width > tabletViewScreenSize) {
      setSlidesToShow(1);
    }
  }, [width]);

  return (
    <div className={styles['carousel-container']}>
      {children.length > 2 && (
        <button
          className={twMerge(
            'tw-hidden tw-items-center tw-justify-center min-[1490px]:tw-left-[20px] min-[1490px]:tw-flex',
            'button--styleless',
            styles['carousel-button'],
            styles['carousel-button--left']
          )}
          onClick={() => carouselRef.current?.slickPrev()}
        >
          <img src={Caret} alt="arrow left" />
        </button>
      )}
      <Slider
        autoplay={false}
        centerMode={slidesToShow === 1}
        dots
        infinite
        variableWidth={width > minVariableWidth}
        speed={1000}
        arrows={false}
        slidesToScroll={1}
        centerPadding="0px"
        className="tw-w-[calc(320px+2.5rem)] tw-max-w-full min-[860px]:tw-w-[calc(645px+5rem)] lg:tw-w-[calc(800px+5rem)] min-[1320px]:tw-w-[calc(1200px+5rem)]"
        dotsClass={`slick-dots ${styles['carousel-dots']}`}
        slidesToShow={slidesToShow}
        ref={carouselRef}
      >
        {children}
      </Slider>
      {children.length > 2 && (
        <button
          className={twMerge(
            'tw-hidden tw-items-center tw-justify-center min-[1490px]:tw-right-[20px] min-[1490px]:tw-flex',
            'button--styleless',
            styles['carousel-button'],
            styles['carousel-button--right']
          )}
          onClick={() => carouselRef.current?.slickNext()}
        >
          <img src={Caret} alt="arrow right" />
        </button>
      )}
    </div>
  );
};

export default MediaSlider;
